import { PropsWithChildren, useMemo } from 'react';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import { CompositeDocumentStorageContext } from 'domain/shared/documentStorage';

export const OpportunityDocumentStorageContext = ({ children }: PropsWithChildren) => {
  const { isFeatureEnabled } = useFeatureToggle();
  const isNewStorageAvailable = isFeatureEnabled(Features.OPPORTUNITY_SERVICE_UPDATE);

  const value = useMemo(
    () => ({
      isDocumentStorageAvailable: isNewStorageAvailable,
    }),
    [isNewStorageAvailable],
  );

  return <CompositeDocumentStorageContext.Provider value={value}>{children}</CompositeDocumentStorageContext.Provider>;
};
